module.exports = {
  cmsUrl: 'https://www.angelasielski.com/data.json',
  frontendUrl: 'https://www.angelasielski.com'
}
